import React from 'react';
import {Label, TextArea, TextField} from "react-aria-components";



export default function TEXTAREA({ description, disabled, errors, id, label, maxLength, name, onChange, placeholder, value }) {

    //  event functions ------------------------------------------------------------------------------------------------
  let error = errors?.find(item => item.name === name);

    // RENDER ==========================================================================================================
    return (
      <TextField>
        <Label htmlFor={id}>{label}</Label>
        <TextArea
          aria-labelledby={id}
          disabled={disabled || false}
          id={id}
          maxLength={maxLength || 500}
          name={name}
          onChange={onChange}
          placeholder={placeholder || ''}
          value={value || ''}
        />
        {error && <div className='error text--sm-regular'>{error.description}</div>}
        {description && <div className='description text--sm italic color--gray--500'>{description}</div>}
      </TextField>
    );

};